import { useHover } from '@uidotdev/usehooks';
import { Edit2, Trash } from 'iconsax-react';
import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
interface IProps {
  data: any;
  elData: any;
  tableData: any;
  setSelectedEl: (value: any) => void;
  i: any;
  visible: any;
  setVisible: React.Dispatch<any>;
  type: string;
  setTitleModal: React.Dispatch<React.SetStateAction<string>>;
  setData: React.Dispatch<any>;
  setSelectedType: React.Dispatch<React.SetStateAction<string>>;
}
const ActionItems: React.FC<IProps> = ({
  data,
  tableData,
  setSelectedEl,
  i,
  setVisible,
  visible,
  type,
  setTitleModal,
  setData,
  setSelectedType,
}) => {
  const [editRef, editHovering] = useHover<HTMLDivElement>();
  const [removeRef, removeHovering] = useHover<HTMLDivElement>();

  const handleDelete = () => {
    const cloneData = JSON.parse(JSON.stringify(data));
    cloneData[type].splice(i, 1);
    setData(cloneData);
  };

  return (
    <>
      <IconWrapper
        ref={editRef}
        style={{
          color: editHovering ? theme.colors.blue_500 : theme.colors.dark_200,
        }}
      >
        <Edit2
          size='24'
          onClick={() => {
            setSelectedType(type);
            setVisible({ ...visible, edit: true });
            setSelectedEl({ data: tableData[i], i: i });
            setTitleModal(
              type === 'section1_localizations'
                ? 'Edit Section 1'
                : type === 'section2_localizations'
                ? 'Edit Section 2'
                : type === 'section3_localizations'
                ? 'Edit Section 3'
                : 'Edit Section 4',
            );
          }}
        />
      </IconWrapper>
      <IconWrapper
        ref={removeRef}
        style={{
          color: removeHovering ? theme.colors.red_500 : theme.colors.dark_200,
        }}
      >
        <Trash size='24' onClick={handleDelete} />
      </IconWrapper>
    </>
  );
};

export default ActionItems;

const IconWrapper = styled.div`
  cursor: pointer;
`;
